import { ProfileDataType } from "../types/ProfileDataType";

interface DocumentType {
  type: string;
  fileName: string;
  documentId: string;
}

export const mapProfileData = (data: any): ProfileDataType | null => {
  if (!data) return null;

  const customer = data.customer || {};
  const address = data.address || {};
  const bank = data.bank || {};
  const documents = Array.isArray(data.documents) ? data.documents : [];

  const getDocumentsByPrefix = (prefix: string) =>
    documents
      .filter((doc: DocumentType) => doc?.type?.startsWith(prefix))
      .map((doc: DocumentType) => ({
        name: doc?.fileName || "",
        link: doc?.documentId || "",
      }));

  return {
    customerAgreements: {
      signed: getDocumentsByPrefix("signed_"),
      unsigned: documents.find((doc: any) => doc.type === "unsigned_agreement"),
    },
    companyDetails: {
      outletName: customer.outletName || "",
      gstNumber: customer.companyGSTNumber || "",
      panNumber: customer.companyPANNumber || "",
      registeredAddress: address.registeredAddress || "",
      authorizedSignatory: customer.companySignatoryName || "",
      vatNo: customer.vatNumber || "",
      email: customer.emailId || "",
      pincode: customer.pincode || "",
      gstStateCode: customer.gstStateCode || "",
      phoneNumber: customer.phoneNumber || "",
      documents: getDocumentsByPrefix("comp_"),
    },
    licenseDetails: {
      licenseName: address.licenseName || "",
      licenseType: address.licenseType || "",
      customerExciseRegistrationNumber: address.exciseRegistrationNumber || "",
      licensePanNumber: address.licensePANNumber || "",
      licenseGstNumber: address.licenseGSTNumber || "",
      licenseAddress: address.licenseAddress || "",
      gstStateCode: address.gstStateCode || "",
      documents: getDocumentsByPrefix("lic_"),
    },
    bankDetails: {
      bankName: bank.bankName || "",
      bankBranch: bank.bankBranch || "",
      accountType: bank.accountType || "",
      accountNumber: bank.bankAccountNumber || "",
      ifscCode: bank.ifscCode || "",
      beneficiaryName: bank.beneficiaryName || "",
      accountsDepartmentPOCName: bank.accountsDeptPOCName || "",
      accountsDepartmentPOCNumber: bank.accountsDeptPOCNumber || "",
      documents: getDocumentsByPrefix("bank_"),
    },
  };
};
